'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var __chunk_1 = require('./chunk-e87a78a6.js');
require('string-hash');
require('asap');
require('inline-style-prefixer/lib/createPrefixer');
require('inline-style-prefixer/lib/plugins/backgroundClip');
require('inline-style-prefixer/lib/plugins/calc');
require('inline-style-prefixer/lib/plugins/crossFade');
require('inline-style-prefixer/lib/plugins/cursor');
require('inline-style-prefixer/lib/plugins/filter');
require('inline-style-prefixer/lib/plugins/flex');
require('inline-style-prefixer/lib/plugins/flexboxIE');
require('inline-style-prefixer/lib/plugins/flexboxOld');
require('inline-style-prefixer/lib/plugins/gradient');
require('inline-style-prefixer/lib/plugins/imageSet');
require('inline-style-prefixer/lib/plugins/logical');
require('inline-style-prefixer/lib/plugins/position');
require('inline-style-prefixer/lib/plugins/sizing');
require('inline-style-prefixer/lib/plugins/transition');

var useImportant = true; // Add !important to all style definitions

var Aphrodite = __chunk_1.makeExports(useImportant);
var StyleSheet = Aphrodite.StyleSheet,
    StyleSheetServer = Aphrodite.StyleSheetServer,
    StyleSheetTestUtils = Aphrodite.StyleSheetTestUtils,
    css = Aphrodite.css,
    minify = Aphrodite.minify,
    flushToStyleTag = Aphrodite.flushToStyleTag,
    injectAndGetClassName = Aphrodite.injectAndGetClassName,
    defaultSelectorHandlers = Aphrodite.defaultSelectorHandlers;

exports.StyleSheet = StyleSheet;
exports.StyleSheetServer = StyleSheetServer;
exports.StyleSheetTestUtils = StyleSheetTestUtils;
exports.css = css;
exports.minify = minify;
exports.flushToStyleTag = flushToStyleTag;
exports.injectAndGetClassName = injectAndGetClassName;
exports.defaultSelectorHandlers = defaultSelectorHandlers;



//////////////////
// WEBPACK FOOTER
// ./~/aphrodite/lib/index.js
// module id = 4
// module chunks = 0